export default `
    <div class="toggle #=data.bsc||""#">
        <span data-label-for-id="#= data.id #" class="toggle-label bind-label" data-bind="text: #= data.labelTrue #">
        </span>
        <span class="toggle-switch-wrapper" id="#= data.id #_Wrapper" # if (data.toolTip) { # title="#= data.toolTip #" # } #>
            <input # if (data.disabled || data.rightLocked) { # disabled # } # id="#= data.id #" type="checkbox" class="bind-value toggle-input #= data.className # # if (data.rightLocked) { # right-locked # } #" data-bind="checked: #= data.bindValue #"/>
            <label for="#= data.id #" class="toggle-switch-container" # if (data.disabled || data.rightLocked) { # disabled # } #>
                <span class="toggle-switch" # if (data.disabled || data.rightLocked) { # disabled # } #>
                </span>
            </label>
        </span>
        <span data-label-for-id="#= data.id #" class="toggle-label bind-label" data-bind="text: #= data.labelFalse #">
        </span>
    </div>
`;
